import { Gift, Sparkles, HeartPulse, Skull, Zap, Wrench } from "lucide-react";

const KIND = {
  give: { icon: Gift, color: "#22c55e", label: "GIFT" },
  buff: { icon: Sparkles, color: "#a855f7", label: "BUFF" },
  heal: { icon: HeartPulse, color: "#ec4899", label: "CARE PACKAGE" },
  summon: { icon: Skull, color: "#ef4444", label: "INCOMING" },
  mischief: { icon: Zap, color: "#f59e0b", label: "MISCHIEF" },
  custom: { icon: Wrench, color: "#3b82f6", label: "SPECIAL" },
};

export const McGiftAlert = ({ ev, style, testid = "overlay-mc-gift" }) => {
  if (!ev) return null;
  const k = KIND[ev.item_kind] || KIND.custom;
  const Icon = k.icon;
  const who = ev.username || ev.who || "Someone";
  return (
    <div className="animate-fade-up" style={{ ...style, zIndex: 35 }} data-testid={testid}>
      <div className="relative flex items-center gap-4 rounded-2xl pl-4 pr-6 py-3 min-w-[380px] max-w-[560px]" style={{ background: "rgba(10,10,10,0.88)", border: `1px solid ${k.color}`, boxShadow: `0 0 36px ${k.color}66, inset 0 0 0 1px ${k.color}22`, backdropFilter: "blur(14px)" }}>
        <div className="relative shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{ background: `${k.color}22`, border: `2px solid ${k.color}` }}>
          <Icon className="w-7 h-7" style={{ color: k.color }} />
          <span className="absolute inset-0 rounded-full" style={{ border: `2px solid ${k.color}`, animation: "mc-gift-ring 1.4s ease-out infinite" }} />
        </div>
        <div className="leading-tight min-w-0">
          <div className="text-[10px] font-800 tracking-widest" style={{ color: k.color, fontFamily: "Outfit, sans-serif" }}>{ev.source === "twitch redeem" ? "CHANNEL POINTS · " : "DONATION · "}{k.label}</div>
          <div className="text-white text-lg font-800 truncate" style={{ fontFamily: "Outfit, sans-serif" }} data-testid={`${testid}-headline`}>{who} <span className="text-white/60 font-medium">sent</span> {ev.item}</div>
          <div className="text-white/70 text-xs truncate">→ {ev.on_pancake ? "PancakeCupCake_" : ev.player}{ev.note ? <span className="italic text-pink-200"> · "{ev.note}"</span> : null}</div>
          {ev.reaction && <div className="text-pink-300 text-xs mt-1 truncate" data-testid={`${testid}-reaction`}>“{ev.reaction}”</div>}
        </div>
      </div>
      <style>{`@keyframes mc-gift-ring { from { transform: scale(1); opacity: .8; } to { transform: scale(1.7); opacity: 0; } }`}</style>
    </div>
  );
};
